<template>
    <div class="orderconfirm">
        <div class="steps">
            <div class="steps_box">
                <el-steps :active="active" finish-status="success">
                    <el-step title="确认订单信息"></el-step>
                    <el-step title="确认付款"></el-step>
                    <el-step title="完成订购"></el-step>
                </el-steps>
            </div>
            <p class="shop_name">订购店铺：{{hostname}}</p>
        </div>
        <div class="order_info">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="servicename" label="服务名称"></el-table-column>
                <el-table-column prop="expireendtime" label="到期日期" align="center"></el-table-column>
                <el-table-column prop="memo" label="订单说明" align="center"></el-table-column>
                <el-table-column prop="price" label="服务价格(元)" align="right">
                    <template slot-scope="scope">￥{{scope.row.price}}</template>
                </el-table-column>
            </el-table>
        </div>
        <div class="price_box">
            <div class="price_tips">应付：<span>￥{{price}}</span></div>
            <div class="pay_btn" @click="pay">立即支付</div>
        </div>
    </div>
</template>

<script>
import {getShopmoduleorderinfo, getOrderPayUrl, getShopmoduleBuyInfo, uploadModuleBuyOrder} from '@/api/orderService'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'orderConfirm',
    data() {
        return {
            active: 1,
            tableData: [],
            hostname: '',
            price: '',
            modulecode: this.$route.query.modulecode ? this.$route.query.modulecode : '',
            item: {
                modulecode: '',
                shopvertype: '',
                modulevertype: ''
            }
        }
    },
    mounted() {
        this._getView()
    },
    methods: {
        _getView() {
            this.setLoading(true)
            getShopmoduleBuyInfo({
                data: {modulecode: this.modulecode},
                success: data => {
                    this.setLoading(false)
                    if (data.data) {
                        let list = []
                        list.push({
                            servicename: data.data.modulename,
                            expireendtime: data.data.expireendtime,
                            memo: data.data.memo,
                            price: data.data.modulemoney
                        })
                        this.tableData = list
                        this.hostname = data.data.hostname
                        this.price = data.data.modulemoney
                        this.item = {
                            modulecode: this.modulecode,
                            shopvertype: 1, // 1标准版 2专业版 3旗舰版"
                            modulevertype: data.data.modulevertype
                        }
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        pay() {
            this.setLoading(true)
            uploadModuleBuyOrder({
                data: this.item,
                success: data => {
                    this.setLoading(false)
                    data = data.data
                    if (data.paycode === '902') {
                        window.location.href = data.payurl
                    } else {
                        this.$router.push({name: 'payResult', query: {orderid: data.orderno, result: 'Y', flag: 1}})
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取订单信息
        getOrderInfo() {
            let data = {
                type: this.type
            }
            this.setLoading(true)
            getShopmoduleorderinfo({
                data: data,
                success: data => {
                    this.setLoading(false)
                    if (data.data) {
                        let list = []
                        list.push({
                            servicename: data.data.servicename,
                            duration: '12个月',
                            price: data.data.finalpaymoney
                        })
                        this.tableData = list
                        this.hostname = data.data.hostname
                        this.price = data.data.finalpaymoney
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        // 去支付
        toPay() {
            // this.$router.push({name: 'payResult', query: {'orderno': this.orderno}})
            // return
            let data = {
                orderno: this.orderno
            }
            this.setLoading(true)
            getOrderPayUrl({
                data: data,
                success: data => {
                    this.setLoading(false)
                    if (data.data) {
                       let url = data.data
                       console.log(url)
                       window.location = url
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        ...mapActions ([
            'setLoading'
        ])
    }
}
</script>

<style lang="scss">
.orderconfirm {
    background: #fff;
    .steps {
        padding: 40px 30px 20px;
        .steps_box {
            /*width: 1080px;*/
            margin: 0 auto;
            .el-steps {
                .el-step {
                    .el-step__head {
                        .el-step__line {
                            top: 22px;
                        }
                        .el-step__icon {
                            width: 40px;
                            height: 40px;
                            .el-step__icon-inner {
                                font-size: 20px;
                                color: #303133;
                            }
                            .el-icon-check {
                                color: #409EFF;
                            }
                        }
                    }
                    .is-success {
                        color: #409EFF;
                        border-color: #409EFF;
                    }
                    .el-step__main {
                        .el-step__title {
                            font-size: 16px;
                            color: #303133;
                            font-weight: 500;
                        }
                        .is-success {
                            color: #409EFF;
                        }
                    }
                }
            }
        }
        .shop_name {
            margin-top: 60px;
            font-size: 16px;
            color: #303133;
        }
    }
    .order_info {
        padding: 0 30px;
    }
    .price_box {
        height: 75px;
        padding: 20px 30px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        .price_tips {
            font-size: 14px;
            color: #303133;
            span {
                font-size: 20px;
                color: #F56C6C;
            }
        }
        .pay_btn {
            width:104px;
            height: 36px;
            background: rgba(245,108,108,1);
            border-radius: 4px;
            font-size: 14px;
            color: #fff;
            line-height: 36px;
            text-align: center;
            cursor: pointer;
        }
    }
}
</style>


